import React, { useEffect, useState } from "react";
import { apiRequest } from "../../../hooks/apiRequest";
import SelectAsync from "react-select/async";
import Select from 'react-select';
import Loader from "../../general/Loader";
import { getLink, objectToFormData, toast } from "../../../utils/helpers";
import { postRequest } from "../../../utils/request";
import { apiUrl } from "../../../utils/apiUrl";

const CrearCartaForm = ({defaultTemplate, toggle}) => {
    const [saving, setSaving] = useState(false);
    const [template, setTemplate] = useState(defaultTemplate);
    const [contacto, setContacto] = useState();
    const [errors, setErrors] = useState({});
    const [contactos, setContactos] = useState([]);
    
    const getTemplates = async (search) => {
        const response = await apiRequest({}, `templates?buscar=${search}`, 'get');

        return response.data.map((template) => ({
            label: template.titulo,
            value: template.id,
            tipo: template.tipo,
        }));
    };

    const getContatos = async () => {
        const response = await apiRequest({}, `cartas/contactos-options?tipo=${template?.tipo}`, 'get');

        setContactos(response.data)
    };

    const crear = async () => {
        setSaving(true);

        setErrors({});

        const [type, id] = contacto.value.split('|');
        const data = objectToFormData({
            template_id: template.value,
            contactable: {
                type,
                id,
            },
        });
        
        const response = await postRequest(apiUrl("cartas"), data);

        
        if (response.success) {
            toast('Carta Creada', 'success');
            toggle(false);
            window.open(getLink(`/imprimir/cartas/${response.data.id}`), '_blank');
        }

        if (response.code === 422) {
            setErrors(response.data.message);
        }

        // insertar la carta.
        // if error set error
        // if not error open print letter

        setSaving(false);
    };

    useEffect(() => {
        getContatos();
    }, [template]);
    
    return <>
        <div className='popup__header'>Crear Carta</div>
        <div className='popup__body'>
            <br/>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Contacto:
                    </label>
                </div>
                <div className='col col-md-7'>
                    <Select
                        name="contacto"
                        key="contacto"
                        isClearable
                        required
                        menuPosition="fixed"
                        options={contactos}
                        onChange={setContacto}
                        value={contacto}
                        styles={{
                            menuList: (styles) => ({
                                ...styles,
                                height: "120px",
                            }),
                        }}
                    />
                    {errors.contacto_id && (
                        <small className='help-blockParams form-Text'>
                            {errors.contacto_id[0]}
                        </small>
                    )}
                    {errors.contacto_type && (
                        <small className='help-blockParams form-Text'>
                            {errors.contacto_type[0]}
                        </small>
                    )}
                </div>
            </div>

            <br/>

            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>
                        Plantilla:
                    </label>
                </div>
                <div className='col col-md-7'>
                    {defaultTemplate && (<div className="form-control" style={{backgroundColor: '#e9ecef'}}>
                        {defaultTemplate.label}
                    </div>)}
                    
                    {!defaultTemplate && <SelectAsync
                        name="template_id"
                        isClearable
                        cacheOptions
                        defaultOptions
                        placeholder="Seleccionar..."
                        onChange={setTemplate}
                        loadOptions={getTemplates}
                        value={template}
                    />}
                    {errors.template_id && (
                        <small className='help-blockParams form-Text'>
                            {errors.template_id[0]}
                        </small>
                    )}
                </div>

                <br/><br/>
            </div>
        </div>
        <div className='popup__footer'>
            <button type='button' onClick={() => toggle(true)} className='btn btn-plain'>Cancelar</button>
            {saving && <Loader type="small"/>}
            {!saving && (<button type='button' className='btn btn-primary' onClick={crear}>Crear</button>)}
        </div>
    </>;
};

export default CrearCartaForm;